import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Утилита для объединения CSS классов с поддержкой Tailwind
 * Использует clsx для условных классов и tailwind-merge для дедупликации
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
